/* Import your third-Party plugins here */
import 'js/modernizr.js'
import 'js/browserdetect.js'
import 'js/iefix.js'
import 'js/anime.min.js'
import 'js/jquery.min.js'



// WEBPACK FOOTER //
// ./src/plugins.js